import { render, staticRenderFns } from "./NormalSearchNav445.vue?vue&type=template&id=6d63cd24&scoped=true&"
import script from "./NormalSearchNav445.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav445.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63cd24",
  null
  
)

export default component.exports